import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';
import { Skeleton } from 'antd';

import { AspectRatio } from '../../Common/AspectRatio';

const ImgWrapper = styled.div``;

const Layout = styled.div<CardProps>`
  display: flex;
  flex-direction: column;

  &.horizontal {
    flex-direction: row;

    ${ImgWrapper} {
      width: 50%;
      margin-right: 16px;
    }

    &.rtl {
      flex-direction: row-reverse;

      ${ImgWrapper} {
        margin-right: 0;
        margin-left: 16px;
      }
    }
  }
`;

interface CardProps {
  directional?: 'vertical' | 'horizontal';
  rtl?: boolean;
  withImage?: boolean;
}

export const Card = (props: CardProps) => {
  const { directional = 'vertical', rtl = false, withImage = true } = props;
  return (
    <Layout className={cl(directional, { rtl })}>
      {withImage && (
        <ImgWrapper>
          <AspectRatio
            ratio={3 / 2}
            borderRadius="8px"
            overflow="hidden"
            backgroundColor="gray20"
          />
        </ImgWrapper>
      )}
      <Skeleton active />
    </Layout>
  );
};
